import './Timepicker.css'

import React, {
  useEffect,
  useRef,
  useState
} from 'react'

import className from 'classnames'

import Button from '../Button/Button'
import ButtonGroup from '../Button/ButtonGroup/ButtonGroup'
import Checkbox from '../Checkbox/Checkbox'
import { defaultTimezone } from '../DateTime/helper'
import {
  ITimePicker,
  ITimeSlider
} from '../DateTime/interfaces'
import DSTTimeZoneList from '../DateTime/TimeZoneList'
import Icon from '../Icon2/Icon'
import InfoModal from '../InfoModal/InfoModal'
import TextInput from '../TextInput/TextInput'
import { TimePickerMask } from './TimePickerMask'
import TimeZoneStandard from './TimeZoneStandard'

const TimeSlider: React.FunctionComponent<ITimeSlider> = (props) => {
	const { name, value, onClick, min, max }: any = props
	return (
		<div className={`TimePicker__time TimePicker__time--${name}`}>
			<div className="TimePicker__time__title" data-test-id={`cs-time-picker-time-${name.toLowerCase()}-title`}>{name}</div>
			<div className="TimePicker__time__box">
				<TextInput
					testId="cs-time-picker-time-input"
					type="number"
					placeholder={'00'}
					value={value}
					className="TimePicker__time__value"
					min={min}
					max={max}
					onFocus={(event) => {
						event.preventDefault()
						event.stopPropagation()
					}}
					onChange={(event) => {
						event.preventDefault()
						onClick(event.target.value)
					}}
				/>
			</div>
		</div>
	)
}

const filterTimezoneValue = (tz: any) => {
	if (tz.includes(':')) {
		return tz.replace(':', '')
	} else {
		return tz
	}
}

const TimePicker2: React.FunctionComponent<ITimePicker> = (props) => {
	const { initialDate, onChange, viewType, onDone, onCancel, closeModal, useVisitorTimezone,
		useVisitorTimezoneOnChange,
		hasVisitorTimezoneCheckBox, doneCtaTestId, cancelCtaTestId,
		onOpen, version, shouldTimePickerModalOpen, inputMaskTestId,
		inputMaskDisabled, placeholder, onClose, timeInputSuffix, timeZoneSuffix,
		testId, timeZoneTestId, timePickerWidth, timezoneWidth, withPortal, portalId, portalProps, timeZoneInPortal, timezonePortalId, timeZoneDropdownPortalProps, isDateTimeCombo } = props

	const initialDate2 = initialDate ? initialDate : '' //'00:00:00+0000';
	const getTimeZone = initialDate2.includes('+') ? initialDate2.split('+') : initialDate2.split('-')
	const getTimeArray = getTimeZone[0].split(':')
	const [time, setTime] = useState(initialDate2)
	const [hours, setHours] = useState<any>(getTimeArray[0] ? parseInt(getTimeArray[0]) : '')
	const [minutes, setMinutes] = useState<any>(getTimeArray[1] ? parseInt(getTimeArray[1]) : '')
	const [seconds, setSeconds] = useState<any>(getTimeArray[2] ? parseInt(getTimeArray[2]) : '')

	const [zone, setZone] = useState(
		initialDate2 && initialDate2[0] ? (getTimeZone[1] ? (initialDate2.includes('+') ? filterTimezoneValue(`+${getTimeZone[1]}`) : filterTimezoneValue(`-${getTimeZone[1]}`)) : `${new Date().toString().split('GMT')[1].split(' (')[0]}`) : `${new Date().toString().split('GMT')[1].split(' (')[0]}`
	)

	const [dstZone, setDstZone] = useState(zone ? defaultTimezone(zone) : '')
	const [useUserTimezone, setUseUserTimezone] = useState(Boolean(useVisitorTimezone));

	useEffect(() => {
		if (version !== "v2") {
			const selectedTime = `${hours > 0 && hours < 10 ? '0' + hours : hours || '00'}:${minutes > 0 && minutes < 10 ? '0' + minutes : minutes || '00'
				}:${seconds > 0 && seconds < 10 ? '0' + seconds : seconds || '00'}${zone ? zone : ''}`

			if (onChange) {
				onChange(selectedTime, zone || '')
			}
		}
	}, [hours, minutes, seconds, zone])

	useEffect(() => {
		if (initialDate && version === "v2") {
			setTimePickerValue(initialDate);
			if (props.withDefaultTimezone) {
				const newSetZoneValue = initialDate2 && initialDate2[0]
					? (getTimeZone && getTimeZone[1]
						? (initialDate2.includes('+')
							? filterTimezoneValue(`+${getTimeZone[1]}`)
							: filterTimezoneValue(`-${getTimeZone[1]}`))
						: `${new Date().toString().split('GMT')[1]?.split(' (')[0] || ''}`)
					: `${new Date().toString().split('GMT')[1]?.split(' (')[0] || ''}`;
				setZone(newSetZoneValue);
				setDstZone(newSetZoneValue ? defaultTimezone(newSetZoneValue) : '');
			}
		}
	}, [initialDate])

	const currZoneObj = zone
		? DSTTimeZoneList().find((singleZoneObj) => zone === singleZoneObj.offsetString)
		: { label: '(GMT +5:30) India Standard Time - Kolkata', value: '+0530' }
	const [timeObj, setTimeObj] = useState(currZoneObj)

	//version2 of timepicker states
	const timeTargetRef = useRef(null)
	const [isTimePickerModalOpen, setIsTimePickerModalOpen] = useState(false)
	const [timePickerValue, setTimePickerValue] = useState(initialDate2)

	const hourChangeHandler = (value: any) => {
		const hour = parseInt(value)

		if (hour >= 0 && hour < 24) {
			setHours(parseInt(value))
		}
	}
	const minuteChangeHandler = (value: any) => {
		const minute = parseInt(value)

		if (minute >= 0 && minute < 60) {
			setMinutes(parseInt(value))
		}
	}
	const secondChangeHandler = (value: any) => {
		const second = parseInt(value)

		if (second >= 0 && second < 60) {
			setSeconds(parseInt(value))
		}
	}
	const zoneHandler = (zone: any, obj: any) => {
		setZone(obj.offsetString)
		setDstZone(zone)
		setTimeObj(obj)
		let shouldCallDone: any = timeObj?.offsetString ? (timeObj.offsetString !== obj.offsetString) : (timeObj?.value !== obj.offsetString)
		if (version === "v2" && shouldCallDone && timePickerValue) {
			const offSetTimeZone = timePickerValue.includes('+') ? timePickerValue.split('+') : timePickerValue.split('-')
			const selectedTimeOffSet: any = offSetTimeZone[0]
			const selectedTime = `${selectedTimeOffSet}${obj.offsetString || ''}`
			setTime(selectedTime)
			if (onChange) onChange(selectedTime, obj.offsetString || '')
			onDone(selectedTime, obj)
		}
	}

	const doneHandler = (timeValue?: any) => {
		let timeSelected = timeValue
		if (version === "v2") {
			if (timeSelected) {
				if (timeValue === "HH:mm:ss") timeSelected = ''
				setTimePickerValue(timeSelected)
				const selectedTime = timeSelected ? `${timeSelected || timePickerValue}${zone ? zone : ''}` : timeSelected
				setTime(selectedTime)
				onDone(selectedTime, timeObj)
			} else {
				onDone('', timeObj)
			}
			setIsTimePickerModalOpen(false)
		} else {
			const selectedTime = `${hours > 0 && hours < 10 ? '0' + hours : hours || '00'}:${minutes > 0 && minutes < 10 ? '0' + minutes : minutes || '00'
				}:${seconds > 0 && seconds < 10 ? '0' + seconds : seconds || '00'}${zone ? zone : ''}`
			setTime(selectedTime)
			onDone(selectedTime, timeObj)
			if (closeModal) {
				closeModal()
			}
		}
	}

	const cancelHandler = () => {
		if (version === "v2") setIsTimePickerModalOpen(false)
		if (onCancel) {
			onCancel(time)
		}
		if (closeModal) {
			closeModal()
		}
	}

	const handlePickerClick = (event: any) => {
		event.stopPropagation()
		if (
			!event.target.parentElement?.classList.contains('TimePicker__time__value') &&
			!event.target?.classList.contains('TimePicker__action') &&
			!event.target.parentElement?.classList.contains('TimePicker__action') &&
			!event.target.parentElement.parentElement?.classList.contains('TimePicker__action')
		) {
			let elems = document.querySelectorAll('.TimePicker__time--focus')
				;[].forEach.call(elems, function (el) {
					el.classList.remove('TimePicker__time--focus')
				})
		}
	}

	const useVisitorTimezoneChangedHandler = () => {
		useVisitorTimezoneOnChange(!useUserTimezone);
		setUseUserTimezone(!useUserTimezone);
	}

	const showTimePickerHandler = () => {
		if (onOpen) onOpen()
		let hasPortalProps: any = {}
		if (withPortal && portalId && document.getElementById(portalId)) {
			hasPortalProps = {
				portal: {
					sourceElem: timeTargetRef.current,
					destinationElem: portalProps?.destinationElem || document.getElementById(portalId),
					AdjustLeftOffset: portalProps?.AdjustLeftOffset || 0,
					// AdjustTopOffset: portalProps?.AdjustTopOffset || -475,
				}
			}
		}
		if (shouldTimePickerModalOpen && !isTimePickerModalOpen) {
			setIsTimePickerModalOpen(true)
			InfoModal({
				component: props => (
					<TimePickerMask
						inputMaskTestId={inputMaskTestId}
						initialDate={timePickerValue}
						onDone={doneHandler}
						onCancel={cancelHandler}
						inputMaskDisabled={inputMaskDisabled}
						placeholder={placeholder}
						viewType={viewType}
						cancelCtaTestId={cancelCtaTestId}
						doneCtaTestId={doneCtaTestId}
						timePickerValue={timePickerValue}
						setTimePickerValue={setTimePickerValue}
						zone={zone}
						dst={dstZone}
						timeObj={timeObj}
						onChange={onChange}
						isDateTimeCombo={isDateTimeCombo}
						{...props}
					/>
				),
				modalProps: {
					targetNodeOrId: timeTargetRef.current,
					closeOnOverlayClick: true,
					className: 'timepicker-modal',
					onClose: (): void => {
						setIsTimePickerModalOpen(false)
						if (onClose) onClose()
					},
					...hasPortalProps
				}
			})
		}
	}

	const onKeyDownHandler = (e: any) => {

	}

	const renderTimeInputSuffix = () => {
		if (timeInputSuffix) {
			return (<span className="TimeInput__suffix__wrapper">{timeInputSuffix}</span>)
		}
		return (<span className="TimeInput__suffix__wrapper">
			<Icon
				className={`ml-16 Dropdown__chevron`}
				icon="Clock"
				version='v2'
				size="medium"
			/>
		</span>)
	}
	const renderTimeZoneSuffix = () => {
		if (timeZoneSuffix) {
			return (<span className="TimeZoneInput__suffix__wrapper">{timeZoneSuffix}</span>)
		}
		return (<span className="TimeZoneInput__suffix__wrapper">
			<Icon
				className={`ml-16 Dropdown__chevron`}
				icon="Global"
				version='v2'
				size="medium"
			/>
		</span>)
	}
	const formatTimeLabelV2 = (timeLabel: string) => {
		let timeLabelToDisplay = timeLabel
		const offSetChar: any = timePickerValue.includes('+') ? '+' : '-'
		if (timeLabel.includes(offSetChar)) {
			timeLabelToDisplay = timeLabel.split(offSetChar)[0]
		}
		return timeLabelToDisplay
	}

	if (version === "v2") {
		// const timezonesSyleObj: any = timezoneWidth ? { width: `${timezoneWidth}px` } : {}
		const timePickerStyleObj: any = timePickerWidth ? { width: `${timePickerWidth}px` } : {}

		return (<div className='TimePicker2__v2 flex-v-center'>
			<div className={`TimePicker2__v2--time__container ${timePickerValue === "" ? 'TimePicker2__v2--empty__placeholder' : ''}`} onClick={showTimePickerHandler}>
				<div style={timePickerStyleObj} data-test-id={testId || 'cs-timepicker-field'} className={`TimePicker--date ${inputMaskDisabled ? 'TimePicker2__v2--disbaled' : ''}`} ref={timeTargetRef} role="button" tabIndex={0} onKeyDown={onKeyDownHandler}>
					{formatTimeLabelV2(timePickerValue) || timePickerValue || "HH:mm:ss"}
				</div>
				{renderTimeInputSuffix()}
			</div>
			<div datat-test-id={timeZoneTestId || 'cs-timezonepicker-field'} className={`TimePicker--timezone TimePicker2__v2--zone__container ${inputMaskDisabled ? 'TimePicker2__v2--disbaled' : ''}`}>
				{<TimeZoneStandard
					dropdownPortalProps={timeZoneInPortal ? {
						portalId: timezonePortalId,
						withPortal: true,
						...timeZoneDropdownPortalProps,
					} : {}}
					timezoneWidth={timezoneWidth}
					version={"v2"}
					dstZone={dstZone}
					zone={zone}
					onChange={zoneHandler}
					disableTzDropdown={inputMaskDisabled}
					isUsingUserTimezone={useUserTimezone}
					hasUserTimezoneCheckBox={hasVisitorTimezoneCheckBox}
					onUseUserTimezoneChange={useVisitorTimezoneChangedHandler}
				/>}
				{renderTimeZoneSuffix()}
			</div>
		</div>)
	}

	return (
		<>
			<div
				className={className('TimePicker', {
					'TimePicker__date-time': viewType === 'datetime'
				})}
				onClick={handlePickerClick}>
				<div className="TimePicker--time">
					<div className="TimePicker__title" data-test-id="cs-time-picker-time">Choose Time</div>
					<div className="flex TimePicker__container ">
						<TimeSlider name="Hour" value={hours} onClick={hourChangeHandler} min={0} max={23} />
						<TimeSlider name="Minute" value={minutes} onClick={minuteChangeHandler} min={0} max={59} />
						<TimeSlider name="Second" value={seconds} onClick={secondChangeHandler} min={0} max={59} />
					</div>
				</div>

				<div className="TimePicker--timezone">
					<div className="TimePicker__title" data-test-id="cs-time-picker-zone">Choose Time Zone</div>
					{<TimeZoneStandard dstZone={dstZone} zone={zone} onChange={zoneHandler} disableTzDropdown={useUserTimezone} />}
				</div>

				{hasVisitorTimezoneCheckBox &&
					<div className='TimePicker--useUserTimezone'>
						<div className="Checkbox-wrapper">
							<Checkbox
								onChange={useVisitorTimezoneChangedHandler}
								label={'User\'s timezone'}
								checked={useUserTimezone}
							/>
							<Icon className='pl-10 TimePicker__icon' icon='InformationOutlineSmall' />
						</div>
					</div>
				}

				{viewType !== 'datetime' && (
					<div className="TimePicker__actions flex-right">
						<ButtonGroup>
							<Button testId={`${cancelCtaTestId ? cancelCtaTestId : 'cs-time-picker-cancel'}`} buttonType="tertiary" onClick={cancelHandler}>
								Cancel
							</Button>
							<Button testId={`${doneCtaTestId ? doneCtaTestId : 'cs-time-picker-done'}`} size="small" buttonType="primary" version='v2' onClick={doneHandler} >
								Done
							</Button>
						</ButtonGroup>
					</div>
				)}
			</div>
		</>
	)
}
export default TimePicker2
